import controller from './modal.controller';
import template from './modal.html';

const modalComponent = {
  restrict: 'E',
  bindings: {
    idvalue: '<',
    isconfirm: '<',
    title: '<',
    text: '<',
    confirm: '&',
    close: '&'
  },
  controller,
  template
};

export default modalComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/modal/modal.component.js
 **/